import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a75ec370"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MyQuoteList" }
const _hoisted_2 = { class: "listItem" }
const _hoisted_3 = { class: "tag" }
const _hoisted_4 = { class: "titleWarpper" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "similar" }, "已结束", -1))
const _hoisted_7 = { class: "descWarpper" }
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = { class: "address" }
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_13 = { class: "other" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("价格: ")
const _hoisted_16 = { class: "count" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("数量: ")
const _hoisted_18 = { class: "time" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("报价方式: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanList, {
      class: "list",
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      onLoad: $setup.getList,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_VanImage, {
                src: !!item.product?require("@/assets/img/list/home_list_gongcheng.png"):require("@/assets/img/list/tag_single.png"),
                width: "34",
                height: "15"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(item.unit), 1)
              ]),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, "详细信息：" + _toDisplayString(item.profile), 1)
            ]),
            _createElementVNode("div", _hoisted_9, "用苗地区: " + _toDisplayString(item.receiptAddress), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, "发布时间:" + _toDisplayString(item.createTime), 1),
              _createVNode(_component_VanButton, {
                size: "small",
                color: "#FFCC32",
                onClick: ($event: any) => ($setup.router.push({name:"BuyDetail",query:{id:item.id}}))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(item.price), 1)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(item.quantity), 1)
              ], 512), [
                [_vShow, item.quantity]
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", null, _toDisplayString(item.payTerm===2?'到货价':'上车价'), 1)
              ])
            ])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["loading", "finished"])
  ]))
}